import { render, staticRenderFns } from "./CreditClassDocument.vue?vue&type=template&id=ca2b0cb6&"
import script from "./CreditClassDocument.vue?vue&type=script&lang=js&"
export * from "./CreditClassDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports